import Live from './Live'
export default {
  component: Live,
  priority: 1,
  permissions: ['ShowLiveClockingsMenu'],
  name: app.translate('routes.home.guardian.Live'),
  icon: 'cctv',
  drawer: true,
};


